import { BaseType } from '../base/base-type';
import { AnnualMinimumProvenanceTypeIdEnum } from './enum/annual-minimum-provenance-type-id.enum';

export class AnnualMinimumProvenanceType extends BaseType {
  public declare id: AnnualMinimumProvenanceTypeIdEnum;
}
